module.exports = __webpack_public_path__ + "static/media/mainsound.a8d21209.mp3";